import { BRAND_NAME } from "@/config";

export const Footer = () => (
  <footer className="mt-24 border-t border-border bg-secondary" data-testid="footer">
    <div className="mx-auto max-w-[1400px] px-5 py-12 md:px-10">
      <p className="text-center text-xs uppercase tracking-[0.2em] text-stone-400">
        © {new Date().getFullYear()} {BRAND_NAME} · By Allure
      </p>
    </div>
  </footer>
);
